import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "wpcm-row m-0" }
const _hoisted_2 = { class: "wpcm-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.props.config.steps)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass($props.config.template_wrapper_class)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "left_sidebar"),
          _createElementVNode("div", {
            class: "wpcm-col col-content",
            style: _normalizeStyle({ backgroundImage: `url(${$props.config.background_image})` })
          }, [
            _renderSlot(_ctx.$slots, "global_top"),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.config.steps, (step) => {
              return (_openBlock(), _createElementBlock("div", {
                key: step + $setup.randKey
              }, [
                (step == $setup.props.currentStep)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: step + $setup.randKey
                    }, [
                      _createElementVNode("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, `step_${step}_ttop`),
                        _renderSlot(_ctx.$slots, `step_${step}_top`),
                        _renderSlot(_ctx.$slots, `step_${step}_middle`),
                        _renderSlot(_ctx.$slots, `step_${step}_bottom`)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            _renderSlot(_ctx.$slots, "global_bottom")
          ], 4 /* STYLE */),
          _renderSlot(_ctx.$slots, "right_sidebar")
        ])
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}